import { useParams } from "react-router-dom";
import { useLazyGetPeerReviewEvaluationDetailsByIdQuery } from "../../../../../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { useSelfEvaluationInfoData } from "../hooks/useSelfEvaluationInfoData";
import SectionA from "../Section/SectionA";
import SectionB from "../Section/SectionB";
import SectionC from "../Section/SectionC";
import { decryptAESID } from "../../../../../../utils/Encryption";
import { useLazyFetch } from "../hooks/useLazyFetch";
import DataLoader from "../../../../../../components/ui/dataLoader/DataLoader";

const SelfEvaluationInfoForm = () => {
    const { isLoading: isDataLoading } = useSelfEvaluationInfoData(); 
    const { id } = useParams()
    const editID = decryptAESID(id, false);
    const { data: getPeerReviewEvaluationDetailsByIdData, isLoading: getPeerReviewEvaluationDetailsByIdLoading, } = useLazyFetch(useLazyGetPeerReviewEvaluationDetailsByIdQuery, editID, !!editID);

  


    if (isDataLoading || getPeerReviewEvaluationDetailsByIdLoading) {
        return <DataLoader />
    }

    return (
        <div className="self-evaluation-page">
            <SectionA />
            <SectionB />
            <SectionC />
            <div className="section-card">
                {/* <div className="commant-box">
                    <label>Comments from Case Officer</label>
                    <textarea value={getPeerReviewEvaluationDetailsByIdData?.caseOfficerComment} className="mt-2" disabled/>
                </div> */}
                <div className="commant-box">
                    <label>Peer Reviewer Comment</label>
                    <textarea value={getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment} className="mt-2" disabled/>
                </div>
                <div className="commant-box">
                    <label>Approver Reviewer Comment</label>
                    <textarea value={getPeerReviewEvaluationDetailsByIdData?.finalApproverComment} className="mt-2" disabled/>
                </div>
            </div>
        </div>
    );
};

export default SelfEvaluationInfoForm;